import { render } from "./edit-service.vue?vue&type=template&id=5b1d8752"
import script from "./edit-service.vue?vue&type=script&lang=js"
export * from "./edit-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__